import Swal from "sweetalert2";

const toastMixin = Swal.mixin({
  toast: true,
  icon: "success",
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

export default toastMixin;
